import React from 'react';
import './ShareButtons.css';
import { newsAPI } from '../utils/api/newsAPI';
import otherNewsAPI from '../utils/api/otherNewsAPI';
import homeNewsAPI from '../utils/api/homeNewsAPI';
import { buildAbsoluteShareUrl } from '../utils/contentEngagement';

/**
 * ShareButtons Component
 * Provides share buttons for WhatsApp, Facebook, Twitter, and Copy Link
 */
function ShareButtons({ title, url, description, contentId, contentType = 'news', compact = false }) {
  const currentUrl = buildAbsoluteShareUrl(url || window.location.href);
  const shareMessage = description ? `${title} - ${description}` : title;

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(shareMessage + ' ' + currentUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}&url=${encodeURIComponent(currentUrl)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareMessage)}`
  };

  const handleCopyLink = async () => {
    try {
      if (contentId) {
        if (contentType === 'other-news') {
          await otherNewsAPI.incrementShare(contentId);
        } else if (contentType === 'home-news') {
          await homeNewsAPI.incrementShare(contentId);
        } else {
          await newsAPI.incrementNewsShare(contentId);
        }
      }

      await navigator.clipboard.writeText(currentUrl);
      alert('लिंक कॉपी हो गया!');
    } catch (error) {
      console.error('Error copying link:', error);
      alert('लिंक कॉपी करने में विफल');
    }
  };

  const handleShare = async (platform) => {
    try {
      if (contentId) {
        if (contentType === 'other-news') {
          await otherNewsAPI.incrementShare(contentId);
        } else if (contentType === 'home-news') {
          await homeNewsAPI.incrementShare(contentId);
        } else {
          await newsAPI.incrementNewsShare(contentId);
        }
      }
    } catch (error) {
      console.error('Failed to record share event:', error);
    }

    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
  };

  return (
    <div className={`share-buttons-container ${compact ? 'compact' : ''}`.trim()}>
      {!compact ? <h4 className="share-title">शेयर करें:</h4> : null}
      <div className={`share-buttons ${compact ? 'compact' : ''}`.trim()}>
        <button 
          className="share-btn whatsapp"
          onClick={() => handleShare('whatsapp')}
          title="WhatsApp पर शेयर करें"
          aria-label="Share on WhatsApp"
        >
          💬 WhatsApp
        </button>
        
        <button 
          className="share-btn facebook"
          onClick={() => handleShare('facebook')}
          title="Facebook पर शेयर करें"
          aria-label="Share on Facebook"
        >
          f Facebook
        </button>
        
        <button 
          className="share-btn twitter"
          onClick={() => handleShare('twitter')}
          title="Twitter पर शेयर करें"
          aria-label="Share on Twitter"
        >
          𝕏 Twitter
        </button>
        
        <button 
          className="share-btn telegram"
          onClick={() => handleShare('telegram')}
          title="Telegram पर शेयर करें"
          aria-label="Share on Telegram"
        >
           Telegram
        </button>

        <button 
          className="share-btn copy"
          onClick={handleCopyLink}
          title="लिंक कॉपी करें"
          aria-label="Copy link"
        >
          🔗 कॉपी करें
        </button>
      </div>
    </div>
  );
}

export default ShareButtons;
